import { QuestionnaireAnswer } from "./questionnaire_answer";
import { Model } from "./model";

export class QuestionnaireQuestion extends Model {
	private sort: number = 0;
	private label: string = "";
	private question: string = "";
	private type: string = "";
	private answers: QuestionnaireAnswer[] = [];
	private input_placeholder: string = "";
	public inputValue: string = "";

	public getSort(): number {
		return this.sort;
	}

	public getLabel(): string {
		return this.label;
	}

	public getQuestion(): string {
		return this.question;
	}

	public getType(): string {
		return this.type;
	}

	public getAnswers(): QuestionnaireAnswer[] {
		return this.answers;
	}

	public setAnswers(list: QuestionnaireAnswer[]): void {
		this.answers = list;
	}

	public getInputPlaceholder(): string {
		return this.input_placeholder;
	}

	public isInputField(): boolean {
		return this.type === "input_field";
	}

	public isSingleChoice(): boolean {
		return this.type === "single_choice";
	}
}
